var _Fragment;
import { Fragment } from "react";
import Navbar from "../MainMenu/ui/Navbar";
import NavbarContainer from "../MainMenu/ui/NavbarContainer";
import SubmenuBackdrop from "../MainMenu/ui/SubmenuBackdrop";
import Logo from "../MainMenu/components/Logo";
import CallCenter from "../MainMenu/components/CallCenter";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LightMenu = function LightMenu() {
  return _Fragment || (_Fragment = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {
      children: /*#__PURE__*/_jsxs(NavbarContainer, {
        className: "flex items-center justify-center lg:justify-between",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex items-center lg:flex-row-reverse",
          children: /*#__PURE__*/_jsx(Logo, {
            targetLink: "_blank"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex items-center",
          children: /*#__PURE__*/_jsx("div", {
            className: "hidden mr-20 lg:block",
            children: /*#__PURE__*/_jsx(CallCenter, {})
          })
        })]
      })
    }), /*#__PURE__*/_jsx(SubmenuBackdrop, {})]
  }));
};
export default LightMenu;